export default "<p>edit-daily-savings works!</p>\n";